export default __webpack_public_path__ + "static/media/closet5-after1-2048w.64fdfcb6.webp";